import React from 'react';
import styled from 'styled-components';
import Utility from '../../../../../../../util/utilityfunctions';
import {inherentRiskTypeId as InherentRiskTypes} from '../../../../../../../util/uiconstants';
import {currentResource, labels} from '../../../../../../../util/utils';
import Icon from '../../../../../../Common/BaseComponentWrappers/MotifIcon';
import Tooltip from '../../../../../../Common/BaseComponentWrappers/MotifTooltip';
import {IconoirWarningTriangle} from '@ey-xd/motif-icon';

export default function InherentRiskTypeCellRenderer(params) {
	const fields = {
		c: [1, 6, 10],
		eo: [2, 7, 11],
		mv: [3, 8, 12],
		ro: [4, 13],
		pd: [5, 9, 14]
	};

	const field = params?.colDef?.field;
	const assertionId = fields[field];

	const data = params?.data;

	if (data?.path?.length === 1) {
		// Show visuals for level 1 (accounts)
		let assertion = null;
		if (data?.assertions?.length > 0) {
			const found = data.assertions.find((as) => assertionId.includes(as.knowledgeAssertionId));
			if (found) {
				const complementaryAssertionInfo = currentResource.assertions.find((as) => assertionId.includes(as.id));
				assertion = {...found, ...complementaryAssertionInfo};
			}
		}

		const inherentRiskTypeId = assertion?.inherentRiskTypeId;

		const noInherentRisk = (
			<Tooltip
				className="noInherentRiskTooltip"
				variant="alt"
				placement="top"
				hideCloseButton
				trigger={
					<section title={labels.risksUnrelatedToAccountAssertion} className="no-inherent-risk">
						<span className="no-inherent-risk-icon">
							<Icon src={IconoirWarningTriangle} />
						</span>
					</section>
				}
			>
				<span className="noInherentRiskTooltipLabel">{labels.ALRAIncompleteInherentRisk}</span>
			</Tooltip>
		);
		const highRisk = <span className="risk high-risk">{labels.ALRAHigherRiskCode}</span>;
		const lowRisk = <span className="risk low-risk">{labels.ALRALowerRiskCode}</span>;
		const notRelevantRisk = <span className="not-relevant-risk">-</span>;

		let label = noInherentRisk;
		if (inherentRiskTypeId === InherentRiskTypes.HIGHER) {
			label = highRisk;
		}
		if (inherentRiskTypeId === InherentRiskTypes.LOWER) {
			label = lowRisk;
		}

		const theme = Utility.getTheme();

		return (
			<StyledInherentRiskTypeRenderer className="StyledInherentRiskTypeRenderer">
				{!assertion ? notRelevantRisk : label}
			</StyledInherentRiskTypeRenderer>
		);
	} else {
		// Show visuals for level 2 (risks)
		const assertionRisk = data.assertionsRisks?.find((assertionrisk) =>
			assertionId.includes(assertionrisk.assertion.knowledgeAssertionId)
		);

		return assertionRisk && <HighLowRiskVisual risk={assertionRisk.risk} />;
	}
}

const StyledInherentRiskTypeRenderer = styled.section`
	display: flex;
	width: 100%;
	justify-content: center;
	.no-inherent-risk {
		display: inline-flex;
		justify-content: center;
		align-items: center;
		border-radius: var(--px-4);
		.no-inherent-risk-icon {
			.motif-icon {
				display: flex;
				justify-content: center;
				svg {
					width: var(--px-20);
					height: var(--px-20);
					color: var(--orange-500) !important;
					cursor: auto;
				}
			}
		}
	}
	.not-relevant-risk {
		background-color: transparent;
		color: #656579;
	}
	.risk {
		background-color: #fff;
		color: #656579;
		border-radius: var(--px-4);
		font-size: var(--px-14);
		font-weight: 400;
		line-height: var(--px-24);
		display: inline-flex;
		justify-content: center;
		align-items: center;
		width: var(--px-28);
		height: var(--px-28);
	}
	.high-risk {
		border: var(--px-1) solid #b14891;
		background-color: #b14891;
		color: #fff;
	}
	.low-risk {
		border: var(--px-2) solid #b14891;
		background: var(--neutrals-00white);
		color: var(--neutrals-1000);
	}
`;

export function HighLowRiskVisual({risk}) {
	let riskVisual = <span className="low-risk" />;
	if (risk && risk.isHigherRisk === true) {
		riskVisual = <span className="high-risk" />;
	}

	return (
		riskVisual && <StyledHighLowRiskVisual className="StyledHighLowRiskVisual">{riskVisual}</StyledHighLowRiskVisual>
	);
}

const StyledHighLowRiskVisual = styled.section`
	display: flex;
	width: 100%;
	justify-content: center;
	.high-risk {
		height: var(--px-14);
		width: var(--px-14);
		background-color: #b14891;
		border-radius: 50%;
		display: inline-block;
		svg {
			color: #fff;
		}
	}
	.low-risk {
		height: var(--px-10);
		width: var(--px-10);
		background-color: #656579;
		border-radius: 50%;
		display: inline-block;
		svg {
			color: #656579;
		}
	}
`;
